import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 104px;
  margin-bottom: 20px;
  background-color: ${Colors.GS200};
`

export const IconContainer = styled.div`
  display: flex;

  align-items: center;
  justify-content: center;

  height: 56px;
  width: 56px;

  border-radius: 16px;

  color: ${Colors.GS0};
  background-color: black;
`

export const ArrowIconContainer = styled.div`
  color: black;
  margin: 0 24px;
`

export const List = styled.ul`
  display: grid;

  grid-auto-flow: row;
  gap: 12px;

  margin-top: 12px;
  margin-bottom: 20px;
`

export const ListItem = styled.li`
  display: grid;
  gap: 10px;
  grid-auto-flow: column;
`

export const ButtonsContainer = styled.div`
  display: grid;

  grid-auto-flow: row;
  gap: 16px;

  margin-top: 20px;
`

export const BulletContainer = styled.span`
  position: relative;
  top: 2px;
`

export const Bold = styled.span`
  font-weight: 700;
`
